import { compose } from 'redux';
import { connect } from 'react-redux';

import { closeSmallDrawer } from 'actions/smallDrawer';

import { FEED_DRAWER_INFORMATIONS } from 'types/smallDrawer';
import injectValidators from 'components/Shared/Forms/injectValidators';
import  { selectors, actions } from '@amplement/backend-connector';

import { getUserByIdSelector } from 'selectors/user';
import InformationBasic from './index';

const mapStateToProps = (state, { _feed }) => {
    const feed = selectors.feeds.feedByIdSelector(state, _feed);
    const user = feed?._user ? getUserByIdSelector(state, feed._user) : undefined;
    const { name, createdAt, color, description } = feed || {};
    const { id: _user, firstname, lastname } = user || {};

    return {
        createdAt,
        initialValues: { feed: { name, description, color: { hex: color } } },
        firstname,
        lastname,
        _user,
        _feed
    };
};

const mapDispatchToProps = (dispatch, { _feed }) => ({
    onClose: () => dispatch(closeSmallDrawer(FEED_DRAWER_INFORMATIONS)),
    onSubmit: (values) => {
        const { color, description, name } = values?.feed || {};
        const feed = {
            color: color.hex,
            description,
            name
        };

        dispatch(actions.feeds.requestPatchMulticastFeed(_feed, feed));
    }
});

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
    injectValidators
)(InformationBasic);
